import { type ReferralStatus, ReferralStatusActive, ReferralStatusExpired, ReferralStatusPending } from '@/api/spec';
import type { ReferralUiStatus } from '../../types';

export const ACTIVATION_WINDOW_DAYS = 7;

export const mapReferralStatus = (apiStatus: ReferralStatus): ReferralUiStatus => {
  if (apiStatus === ReferralStatusActive) return 'active';
  if (apiStatus === ReferralStatusPending) return 'pending';
  if (apiStatus === ReferralStatusExpired) return 'expired';
  return 'inactive';
};

const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const computeDaysLeft = (joinedAtMs: number, now: number = Date.now()): number => {
  const daysElapsed = (now - joinedAtMs) / MS_PER_DAY;
  return Math.max(0, Math.ceil(ACTIVATION_WINDOW_DAYS - daysElapsed));
};

export const computeDaysSinceJoined = (joinedAtMs: number, now: number = Date.now()): number => {
  return Math.max(0, Math.floor((now - joinedAtMs) / MS_PER_DAY));
};

export const computeExpirationMs = (joinedAtMs: number, maxAgeDays: number): number => {
  return joinedAtMs + maxAgeDays * MS_PER_DAY;
};

export const formatIsoDate = (ms: number): string => new Date(ms).toISOString().slice(0, 10);
